import MediaWindow from "components/real-chat/components/MediaWindow";
import Picker, { Theme } from "emoji-picker-react";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { FaRegSmile } from "react-icons/fa";
import { IoSendSharp } from "react-icons/io5";
import { MdOutlineGif } from "react-icons/md";
import { Input } from "antd";
import { BiLogoTelegram } from "react-icons/bi";

const { TextArea } = Input;

function UserChatInput({
  inputValue,
  setInputValue,
  selectedChat,
  sendMessage,
  notifyTyping,
  userIndividualChat = false,
  sidePanel,
}: any) {
  const [showPicker, setShowPicker] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  const pickerRef = useRef<HTMLDivElement>(null);
  const mediaRef = useRef<HTMLDivElement>(null);
  const [textareaHeight, setTextareaHeight] = useState("40px");
  //Click outside for emoji picker
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        setShowPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        mediaRef.current &&
        !mediaRef.current.contains(event.target as Node)
      ) {
        setShowMedia(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onEmojiClick = (event: any) => {
    setInputValue((prevInput: any) => prevInput + event.emoji);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      setInputValue((prevMessage: string) => prevMessage + "\n");
    } else if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (inputValue.trim() !== "") {
        handleSubmit(e);
        setInputValue("");
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (inputValue !== "") {
      sendMessage(inputValue);
      triggerChatOnChange(false);
      setTextareaHeight("40px");
      setInputValue("");
    }
  };

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    setInputValue(e.target.value);
    if (e.target.value !== "") {
      triggerChatOnChange(true);
    } else {
      triggerChatOnChange(false);
    }
  };
  const triggerChatOnChange = (onChnage: boolean) => {
    if (userIndividualChat) {
      notifyTyping(selectedChat.id, selectedChat?.receiver?.id, onChnage);
    } else {
      notifyTyping(onChnage);
    }
  };

  const handleClear = () => {
    setInputValue("");
  };

  const isGifUrl = (url: string) => {
    const gifUrlPattern = /^https:\/\/giphy\.com\/embed\/[a-zA-Z0-9]+$/;
    return gifUrlPattern.test(url);
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="flex w-full items-center justify-between rounded-full border border-white/10 bg-[#1E1E1E] px-2"
      >
        {isGifUrl(inputValue) ? (
          <div className="relative">
            <iframe
              src={inputValue}
              width="100%"
              height="200"
              frameBorder="0"
              className="rounded-lg"
              allowFullScreen
              title="GIF"
            ></iframe>
            <button
              onClick={handleClear}
              className="absolute flex items-center justify-center top-0 right-0 px-1 w-[20px] h-[20px] text-white bg-[#F50537] rounded-full text-[12px]"
            >
              X
            </button>
          </div>
        ) : (
          <>
            <textarea
              placeholder="Type your message..."
              value={inputValue}
              onKeyDown={handleKeyPress}
              onChange={(e) => onChange(e)}
              className="w-full bg-transparent p-2 pl-5 text-white placeholder:text-white/40 max-sm:pl-3 max-sm:text-[13px]"
              style={{ height: textareaHeight, resize: "none" }}
            />
          </>
        )}

        <div className="flex h-[50px] items-center justify-center">
          <FaRegSmile
            className="mx-2 cursor-pointer text-white/50 transition-colors hover:text-white"
            onClick={() => setShowPicker((val) => !val)}
            size={20}
          />

          <MdOutlineGif
            className="mx-2 cursor-pointer rounded-lg border-[1px] border-white/20 text-white/50 transition-colors hover:border-white/40 hover:text-white"
            onClick={() => setShowMedia((val) => !val)}
            size={25}
          />
        </div>
        {showMedia && (
          <div
            className={`absolute ${
              sidePanel ? "w-[80%]" : "w-[25%]"
            } bottom-[12%] right-[7%] overflow-visible max-sm:w-[90%] max-sm:right-[2%] max-sm:bottom-[8%]`}
            ref={mediaRef}
          >
            <MediaWindow
              setInputValue={setInputValue}
              setShowMedia={setShowMedia}
            />
          </div>
        )}
        {showPicker && (
          <div
            className="absolute bottom-[12%] right-[9%] overflow-visible max-sm:right-[10%] max-sm:bottom-[20%] "
            ref={pickerRef}
          >
            <Picker onEmojiClick={onEmojiClick} theme={Theme.DARK} />
          </div>
        )}
        <button
          type="submit"
          className="ml-2 my-1.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#F50537] text-white shadow-[0_4px_14px_rgba(245,5,55,0.4)] transition-all duration-150 hover:bg-[#d90430] active:scale-95"
        >
          <IoSendSharp className="text-white" size={16} />
        </button>
      </form>
    </>
  );
}

export default UserChatInput;
